import api from "../../services/api";
import {
  setTicketTypes,
  setTicketCreated,
  setTicketMessages,
  setTicketSubTypes,
  setDataFilterTickets,
  setDataFilterTicketsInfo,
} from "../slices/customerService.slice";
import { logout } from "./user.middleware";
import { initLoading, endLoading, setError } from "../slices/generics.slice";

export const getSubType = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/ticketTypes`);

      dispatch(setTicketTypes(response?.data?.result?.items));
    } catch (error) {
      console.log("getSubType", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getSubTypeID = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/ticketTypes/${id}/ticketSubTypes`);
      dispatch(setTicketSubTypes(response?.data?.result?.items));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getSubTypeID", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getFilterTickets = (data = {}, page = "list") => {
  return async (dispatch) => {
    dispatch(initLoading());

    const params = new URLSearchParams();
    const filterKeys = [
      "id",
      "role",
      "createdAt",
      "requester",
      "ticketTypeId",
      "creatorUserId",
      "ticketSubTypeId",
      "status",
    ];

    filterKeys.forEach((key) => {
      if (data[key]) params.append(key, data[key]);
    });

    if (data.pageSize) params.append("pageSize", data.pageSize);
    if (data.pageNumber) params.append("pageNumber", data.pageNumber);
    params.append("orderByDesc", "createdAt");

    try {
      const response = await api.get(`/tickets?${params.toString()}`);
      const result = response?.data?.result;
      const items = result?.items || [];

      if (data.id !== "") {
        dispatch(setTicketCreated(items[0]));
      }
      if (page === "list") {
        dispatch(setDataFilterTickets(items));
      }

      dispatch(setDataFilterTicketsInfo(result));
      dispatch(getSubType());
    } catch (error) {
      console.log("getFilter", error);
      dispatch(setError(error.message));
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postTicket = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/tickets`, data);
      const resp = response.data.result.items;
      dispatch(setTicketCreated(resp[0]));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTicket", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postTicketCancel = (id, data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`tickets/${id}/cancel`, data);
      const resp = response.data;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTicketCancel", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postTicketProceed = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`tickets/${id}/proceed`);
      const resp = response.data.result.items[0];
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTicketProceed", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postTicketClose = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`tickets/${id}/close`);
      const resp = response.data;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTicketClose", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const sendTicketMessage = (id, data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`tickets/${id}/ticketMessages`, data);
      const resp = response.data;

      dispatch(getTicketMessages(id));
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("sendTicketMessage", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
      return error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateTicket = (id, data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.put(`tickets/${id}`, data);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("updateTicket", error.message);
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getTicketMessages = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/tickets/${id}/ticketMessages`);
      dispatch(setTicketMessages(response?.data?.result?.items));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getSubTypeID", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const saveExtraClasses = (req) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.put("extraClassesUpdate", req);
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("saveExtraClasses", error);
      dispatch(endLoading());
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};
